/**
 * Articles published by Foundelo, loaded from `./foundelo/<lang>/<slug>.json`
 * at build time (webpack bundles every file the folder holds). See
 * `./foundelo-core.js` for the record shape (applied in articles.js) and `./foundelo/README.md`.
 *
 * The call must stay a plain `require.context(...)`: webpack replaces exactly that
 * call at build time. A `typeof require.context` guard is rewritten by webpack to
 * a module without `.context`, so it was always false in production and the blog
 * loaded no Foundelo article at all. Jest and plain Node have no require.context:
 * the call throws there, and they get none.
 */
function loadFiles() {
  try {
    const ctx = require.context('./foundelo', true, /\.json$/);
    return ctx.keys().map((k) => ctx(k));
  } catch (e) {
    return [];
  }
}

export const foundeloFiles = loadFiles();
